import request from '../common/request';

const url = "";

export function getBusinessData(formData) {
    return request({
        url: url + '/business/getBusinessData',
        method: 'GET',
        params: formData
    });
}
export function getStatistics(formData) {
    return request({
        url: url + '/business/getStatistics',
        method: 'GET',
        params: formData
    });
}

export function staffs(formData) {
    return request({
        url: url + '/business/staffs',
        method: 'GET',
        params: formData
    });
}

export function getAnalyses(formData) {
    return request({
        url: url + '/business/getAnalyses',
        method: 'GET',
        params: formData
    });
}
